import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useFlash } from "../../context/flashcontext";
import { useTimesheetForm } from "../../hooks/useTimesheetForm";
import api from "../../Api";
import TimesheetFormView from "./TimesheetFormView";

function TimesheetFormContainer(props) {
    const { showFlash } = useFlash();
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const preselectedProjectId = searchParams.get('project'); // Get project from query params
    const [initialTimesheet, setInitialTimesheet] = useState(null);
    const [loading, setLoading] = useState(!!id);

    useEffect(() => {
        if (id) {
            setLoading(true);
            api.get(`/timesheets/${id}`)
                .then(res => {
                    setInitialTimesheet(res.data);
                    setLoading(false);
                })
                .catch((err) => {
                    console.error("Error fetching timesheet:", err);
                    setLoading(false);
                });
        }
    }, [id]);

    const hookProps = useTimesheetForm(showFlash, initialTimesheet, preselectedProjectId);

    if (loading) return <p>Weekstaat laden...</p>;
    return <TimesheetFormView {...hookProps} initialTimesheet={initialTimesheet} {...props} />;
}

export default TimesheetFormContainer;

TimesheetFormContainer.propTypes = {
    // Props spread to child view
};
